'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _editTestDriveModal = require('./editTestDrive.modal.html');

var _editTestDriveModal2 = _interopRequireDefault(_editTestDriveModal);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnquiryTestDrivesController = function () {
  function EnquiryTestDrivesController($uibModal, $scope, vehicleService, authService, loadingService, $q) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EnquiryTestDrivesController);
    this.$uibModal = $uibModal;
    this.$scope = $scope;
    this.vehicleService = vehicleService;
    this.authService = authService;
    this.loadingService = loadingService;
    this.$q = $q;

    this.vehicleList = [];
  }

  (0, _createClass3.default)(EnquiryTestDrivesController, [{
    key: 'initializeVehicleList',
    value: function initializeVehicleList() {
      var ctrl = this;
      var deferred = ctrl.$q.defer();

      if (ctrl.vehicleList.length) {
        deferred.resolve();
        return deferred.promise;
      }

      ctrl.loadingService.showLoading('testDrives', 'Loading Vehicles');

      ctrl.vehicleService.locationVehicles(ctrl.authService.authData.currentLocation.key, 'vehicle', ctrl.enquiry.enquiryId).then(function (response) {
        if (response.data.items.length) {
          var itemsArray = response.data.items;
          itemsArray.unshift({
            vehicleId: null,
            model: '--- Please Select ---'
          });
          ctrl.vehicleList = itemsArray;
        }
      }).catch(function (err) {}).finally(function () {
        ctrl.loadingService.hideLoading('testDrives');
        deferred.resolve();
      });

      return deferred.promise;
    }
  }, {
    key: 'editTestDrive',
    value: function editTestDrive(testDrive) {
      var _this = this;

      this.errMsg = '';
      this.saveButtonTitle = 'Add';

      if (testDrive) {
        this.tempTestDrive = testDrive;
        this.tempTestDrive.editMode = true;
        this.tempVehicle = (0, _lodash.find)(this.vehicleList, function (o) {
          return o.vehicleId === _this.tempTestDrive.vehicleId;
        });
        this.saveButtonTitle = 'Update';

        this.$uibModalInstance = this.$uibModal.open({
          template: _editTestDriveModal2.default,
          scope: this.$scope
        });
      } else {
        this.initializeVehicleList().then(function () {
          _this.tempVehicle = _this.vehicleList[0];
          _this.tempTestDrive = {
            isConfirmed: true
          };

          _this.$uibModalInstance = _this.$uibModal.open({
            template: _editTestDriveModal2.default,
            scope: _this.$scope
          });
        });
      }
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.$uibModalInstance.close();
    }
  }, {
    key: 'vehicleSelected',
    value: function vehicleSelected() {
      this.tempTestDrive.vehicleId = this.tempVehicle.vehicleId;
      this.tempTestDrive.model = this.tempVehicle.model;
    }
  }, {
    key: 'addTestDrive',
    value: function addTestDrive() {
      if (!this.tempTestDrive.vehicleId) {
        this.errMsg = 'Please select a Vehicle First';
        return;
      }

      if (!this.tempTestDrive.timeStamp) {
        this.errMsg = 'Please select a Date First';
        return;
      }

      if (!this.tempTestDrive.editMode) {
        this.enquiry.testDrives.push(this.tempTestDrive);
      } else {
        this.tempTestDrive.editMode = false;
      }

      this.closeModal();
    }
  }, {
    key: 'removeTestDrive',
    value: function removeTestDrive(testDrive) {
      this.enquiry.testDrives = (0, _lodash.without)(this.enquiry.testDrives, testDrive);
    }
  }]);
  return EnquiryTestDrivesController;
}();

exports.default = EnquiryTestDrivesController;


// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryEdit/enquiryTestDrives/enquiryTestDrives.controller.js